
import * as React from "react"
import {
  DropdownMenuTrigger as ShadcnDropdownMenuTrigger,
  DropdownMenuItem as ShadcnDropdownMenuItem,
  DropdownMenuLabel as ShadcnDropdownMenuLabel,
  DropdownMenuContent as ShadcnDropdownMenuContent
} from "@/components/ui/dropdown-menu"
import { cn } from "@/lib/utils"

export interface EnhancedDropdownMenuTriggerProps extends React.ComponentPropsWithoutRef<typeof ShadcnDropdownMenuTrigger> {
  children?: React.ReactNode;
  asChild?: boolean;
}

export const EnhancedDropdownMenuTrigger = React.forwardRef<HTMLButtonElement, EnhancedDropdownMenuTriggerProps>(
  ({ children, asChild, ...props }, ref) => {
    return (
      <ShadcnDropdownMenuTrigger ref={ref} asChild={asChild} {...props}>
        {children}
      </ShadcnDropdownMenuTrigger>
    );
  }
);
EnhancedDropdownMenuTrigger.displayName = "EnhancedDropdownMenuTrigger";

export interface EnhancedDropdownMenuItemProps extends React.ComponentPropsWithoutRef<typeof ShadcnDropdownMenuItem> {
  children?: React.ReactNode;
  className?: string;
  onClick?: () => void;
}

export const EnhancedDropdownMenuItem = React.forwardRef<HTMLDivElement, EnhancedDropdownMenuItemProps>(
  ({ children, className, onClick, ...props }, ref) => {
    return (
      <ShadcnDropdownMenuItem 
        ref={ref} 
        className={cn(className)} 
        onClick={onClick} 
        {...props}
      >
        {children}
      </ShadcnDropdownMenuItem>
    );
  }
);
EnhancedDropdownMenuItem.displayName = "EnhancedDropdownMenuItem";

export interface EnhancedDropdownMenuLabelProps extends React.ComponentPropsWithoutRef<typeof ShadcnDropdownMenuLabel> {
  children?: React.ReactNode;
  className?: string;
}

export const EnhancedDropdownMenuLabel = React.forwardRef<HTMLDivElement, EnhancedDropdownMenuLabelProps>(
  ({ children, className, ...props }, ref) => {
    return (
      <ShadcnDropdownMenuLabel ref={ref} className={cn(className)} {...props}>
        {children}
      </ShadcnDropdownMenuLabel>
    );
  }
);
EnhancedDropdownMenuLabel.displayName = "EnhancedDropdownMenuLabel";

export interface EnhancedDropdownMenuContentProps extends React.ComponentPropsWithoutRef<typeof ShadcnDropdownMenuContent> {
  children?: React.ReactNode;
  className?: string;
  align?: "center" | "start" | "end";
}

export const EnhancedDropdownMenuContent = React.forwardRef<HTMLDivElement, EnhancedDropdownMenuContentProps>(
  ({ children, className, align, ...props }, ref) => {
    return (
      <ShadcnDropdownMenuContent ref={ref} className={cn(className)} align={align} {...props}>
        {children}
      </ShadcnDropdownMenuContent>
    );
  }
);
EnhancedDropdownMenuContent.displayName = "EnhancedDropdownMenuContent";

// Re-export the original components
export const DropdownMenuTrigger = EnhancedDropdownMenuTrigger;
export const DropdownMenuItem = EnhancedDropdownMenuItem;
export const DropdownMenuLabel = EnhancedDropdownMenuLabel;
export const DropdownMenuContent = EnhancedDropdownMenuContent;
